// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__I18lb","label":"SetPasswdForm_label__3t9Wv"};